/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const selectAllModule = (state: { module: any }) => state.module.modules;
export const selectNoModule = (state: { module: any }) => state.module.noModule;
export const selectSelectedModule = (state: { module: any }) => state.module.selectedModule;
export const selectAvailableModules = (state: { module: any }) => state.module.availableModules;
export const selectAllFilteredModules = (state: { module: any }) => state.module.filteredModules;
export const selectModulePagination = (state: { module: any }) => state.module.pagination;